/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EnumValue } from './EnumValue';
import {
    EnumValueFromJSON,
    EnumValueFromJSONTyped,
    EnumValueToJSON,
} from './EnumValue';

/**
 * 
 * @export
 * @interface LeadFieldOptionsResponse
 */
export interface LeadFieldOptionsResponse {
    /**
     * 
     * @type {Array<EnumValue>}
     * @memberof LeadFieldOptionsResponse
     */
    values: Array<EnumValue>;
}

/**
 * Check if a given object implements the LeadFieldOptionsResponse interface.
 */
export function instanceOfLeadFieldOptionsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "values" in value;

    return isInstance;
}

export function LeadFieldOptionsResponseFromJSON(json: any): LeadFieldOptionsResponse {
    return LeadFieldOptionsResponseFromJSONTyped(json, false);
}

export function LeadFieldOptionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadFieldOptionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'values': ((json['values'] as Array<any>).map(EnumValueFromJSON)),
    };
}

export function LeadFieldOptionsResponseToJSON(value?: LeadFieldOptionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'values': ((value.values as Array<any>).map(EnumValueToJSON)),
    };
}

